import { DOCUMENT } from '@angular/common';
import { Injectable, Injector, Version, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CanActivate } from '@angular/router';
import { APP_ENVIRONMENT, APP_VERSION } from '@qtek/core/api-core';
import { MetaStore } from '@qtek/libs/store';
import { Environment } from '@qtek/shared/models';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable()
export class IconReadyGuard implements CanActivate {
  private metaStore = inject(MetaStore);
  private injector = inject(Injector);
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);
  private environment = inject<Environment>(APP_ENVIRONMENT);
  private version = inject<Version>(APP_VERSION);
  private document = inject<Document>(DOCUMENT);

  private registered = false;

  canActivate(): Observable<boolean> {
    this.metaStore.loadGuiDomain();

    if (this.registered) {
      return of(true);
    }
    return toObservable(this.metaStore.guiDomain, {
      injector: this.injector,
    }).pipe(
      filter(Boolean),
      take(1),
      map(domain => {
        this.registerIcons(domain);
        this.registered = true;
        return true;
      })
    );
  }

  private registerIcons(domain: string): void {
    let iconsPath: string;

    if (this.environment.production) {
      iconsPath = `${domain}/assets/img/icons/icons.svg?v=${this.version.full}`;
    } else {
      const { host } = this.document.location;
      iconsPath = `//${host}/assets/img/icons/icons.svg?v=${this.version.full}`;
    }

    const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iconsPath);

    this.iconRegistry.addSvgIconSet(safeUrl);
  }
}
